import { RiskDistributionGroupBy } from '../../../../services/dtos/riskProducts/riskDistribution.dto';

export const RISK_DISTRIBUTION_GROUP_BY_LABEL: Record<RiskDistributionGroupBy, string> = {
  [RiskDistributionGroupBy.SECTOR]: 'Sector',
  [RiskDistributionGroupBy.RATING]: 'ACR',
};
